<template>
  <tr :class="payment.deposit ? 'green lighten-5' : ''">
    <td>{{ payment.date_paid | shortDate }}</td>
    <td>
      <table width='100%'>
        <tr>
          <td>
            <v-btn small icon :to="{ name: 'InvoiceOverview', params: { id: payment.invoice } }">
              <v-icon small color='info'>mdi-open-in-new</v-icon>
            </v-btn>
          </td>
          <td>
            {{ payment.invoice_obj_number }}
            <br>
            <small>{{ payment.invoice_bill_to }}</small>
          </td>
        </tr>
      </table>
    </td>
    <td>{{ payment.payment_method_display }}</td>
    <td class='text-right'>{{ payment.amount | dec }}</td>
    <td class='text-center'>
      <wc-checkbox
        :disabled='lockEdits'
        :status='payment.deposit !== null'
        :isLoading='isLoading'
         @toggle='toggleInclusion'
      ></wc-checkbox>
    </td>
  </tr>

</template>

<script>
import WCCheckbox from '@/components/forms/WCCheckbox';
import accountingAPI from '@/api/accounting';
import _ from 'lodash';

export default {
  name: 'deposit-line',
  props: {
    payment: {
      required: true
    },
    lockEdits: {
      required: true,
      type: Boolean,
      default: false
    },
    deposit: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    paymentCopy: {}
  }),
  methods: {
    async toggleInclusion () {
      if (this.deposit.is_locked === false) {
        this.isLoading = true
        this.paymentCopy = _.cloneDeep(this.payment)
        if (this.paymentCopy.deposit) {
          this.paymentCopy.deposit = null
        } else {
          this.paymentCopy.deposit = this.deposit.id
        }
        await accountingAPI.updateInvoicePayment(this.paymentCopy.id, this.paymentCopy)
        this.$emit('updatePayment', this.paymentCopy)
        this.isLoading = false
      }
    }
  },
  components: {
    'wc-checkbox': WCCheckbox
  }
}
</script>
